module.exports = __webpack_public_path__ + "media/images/icons/ic-category-1051d76d2291107c1ac0be9489b8501e.svg";